module.exports = __webpack_public_path__ + "static/media/assicurazioniNew-bg.1d1e501b.jpg";